import { render, staticRenderFns } from "./ProductWeightLayout.vue?vue&type=template&id=223784a6&scoped=true"
import script from "./ProductWeightLayout.vue?vue&type=script&lang=js"
export * from "./ProductWeightLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223784a6",
  null
  
)

export default component.exports